const state: UserStateObj = {
  active: {},
  list: []
};

export default { ...state };
